import { OnboardingProTask } from '@weave/schema-gen-ts/dist/shared/call-intelligence/plg/onboarding.pb';
import { useNavigate } from '@frontend/weave-router';
import { CALL_INTEL_PATH } from '../constant';
import { useProOnboardingActionShallowStore } from '../hooks/use-pro-onboarding-action-store';
import type { TaskAction, TaskActionArgs } from '../types';

export function useOverviewChartDrilldownAction({ onClose }: TaskActionArgs): TaskAction {
  const navigate = useNavigate();

  const { eligibility, isEligibilityResolved, setPendingTask } = useProOnboardingActionShallowStore(
    'eligibility',
    'isEligibilityResolved',
    'setPendingTask'
  );

  const isEnabled = !isEligibilityResolved || eligibility.hasSentimentDrilldownTarget;

  return {
    isEnabled,
    isLoading: false,
    onSelect: () => {
      if (!isEnabled) return;
      setPendingTask(OnboardingProTask.PRO_TASK_OVERVIEW_CHART_DRILLDOWN);
      navigate({ to: CALL_INTEL_PATH });
      onClose();
    },
  };
}
